import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintSuratKuasa = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocSuratKuasa = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT KUASA
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginBottom: "10px" }}>Yang bertanda tangan di bawah ini:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama Lengkap</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. KTP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. Telepon/HP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.phone ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Alamat</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.address ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>
                  <br />
                </td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}></td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Nomor Rekening Tabungan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. SP3K</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Tanggal Akad KPR Bersubsidi</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Nomor Rekening KPR Bersubsidi</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
            </tbody>
          </table>

          <p>
            PT. Bank Tabungan Negara (Persero) Tbk., berkedudukan di Jalan Gajah Mada No. 01 Jakarta Pusat yang dalam hal ini diwakili oleh ..................................................... selaku ......................................................di PT. Bank Tabungan Negara (Persero) Tbk. Kantor Cabang ........................................................ Selanjutnya disebut <span style={{ fontWeight: "bold" }}>“Penerima Kuasa” KHUSUS</span>.
          </p>
          <div style={{ marginTop: "20px" }}>
            dengan ini <span style={{ fontWeight: "bold" }}>Pemberi Kuasa</span> memberikan kuasa kepada Penerima Kuasa untuk dapat melakukan hal-hal sebagai berikut:
          </div>

          <ol style={{ paddingLeft: "15px" }}>
            <li>Membayarkan sejumlah dana kepada Penjual/Pengembang dari hasil pencairan kredit yang diterima oleh Pemberi Kuasa dari Bank BTN untuk pembayaran lunas harga jual rumah beserta lahan sesuai dengan tujuan pemberian kredit.</li>
            <li>Melakukan pemindahbukuan pencairan dana Subsidi Bantuan Uang Muka (SBUM) dari rekening simpanan milik Pemberi Kuasa di Bank BTN sebagaimana tersebut di atas senilai ..........................................................(.........................................................) untuk digunakan sebagai pengurang pokok kredit/pembayaran kekurangan uang muka pembelian Rumah Umum Tapak dalam hal Pemberi Kuasa mendapatkan fasilitas SBUM.</li>
            <li>
              Pembayaran dan pemindahbukuan dana sebagaimana dimaksud pada butir 1 dan butir 2 ditujukan kepada:
              <br />
              <table style={{ borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
                <tbody style={{ border: "1px solid black" }}>
                  <tr style={{ border: "1px solid black" }}>
                    <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama Pengembang</td>
                    <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                    <td style={{ padding: "4px 6px" }}>{""}</td>
                  </tr>
                  <tr style={{ border: "1px solid black" }}>
                    <td style={{ padding: "4px 6px" }}>Nomor Rekening</td>
                    <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                    <td style={{ padding: "4px 6px" }}>{""}</td>
                  </tr>
                  <tr style={{ border: "1px solid black" }}>
                    <td style={{ padding: "4px 6px" }}>Rekening Atas Nama</td>
                    <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                    <td style={{ padding: "4px 6px" }}>{""}</td>
                  </tr>
                  <tr style={{ border: "1px solid black" }}>
                    <td style={{ padding: "4px 6px" }}>Pada Bank</td>
                    <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                    <td style={{ padding: "4px 6px" }}>Bank BTN Kantor Cabang/Kantor Cabang Pembantu/ Kantor Kas .....................................................</td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              Memblokir, mendebet dan/atau memindahbukukan dana dari rekening simpanan milik Pemberi Kuasa di Bank BTN sebagaimana tersebut di atas untuk keperluan pembayaran:
              <br />
              <ol type="a" style={{ paddingLeft: "15px" }}>
                <li>Biaya proses dan/atau prarealisasi kredit;</li>
                <li>Angsuran kredit yang meliputi pokok, bunga, denda, dan biaya lainnya; dan</li>
                <li>Biaya asuransi, pengikatan agunan, dan biaya lainnya yang timbul karena terjadinya penghentikan KPR Bersubsidi BTN dan/atau perubahan/konversi menjadi KPR Non-Subsidi.</li>
              </ol>
            </li>
            <li>Pembayaran, pemindahbukuan, pemblokiran, dan/atau pendebetan dana sebagaimana dimaksud pada butir 1 s.d. butir 4 di atas dapat dilakukan oleh Bank BTN secara manual, otomatis dan/atau mekanisme transaksi yang berlaku di Bank BTN.</li>
          </ol>
          <p>Demikian Surat Kuasa ini dibuat dengan Hak Substitusi, dan tidak dapat dicabut kembali serta tidak akan berakhir karena sebab – sebab yang tercantum dalam Pasal 1813 Kitab Undang – Undang Hukum Perdata atau karena sebab apapun juga.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "80%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    width: "50%",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  PENERIMA KUASA
                  <br />
                  PT. BANK TABUNGAN NEGARA (PERSERO) Tbk.
                  <br />
                  KANTOR CABANG .................................
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <span style={{ fontWeight: "bold" }}>PEMBERI KUASA</span> <br /> <br />
                </td>
              </tr>

              {/* Kotak Materai */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "38px 12px 8px 12px",
                    verticalAlign: "top",
                  }}
                >
                  {/* Kosong untuk tanda tangan kiri */}
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      height: "80px",
                      top: "-20px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
